module.exports = {"back":"Voltar","description":"E você pode contar com a gente para ajudar. É só confirmar seu CPF/CNPJ ou seu e-mail.","modalDescription":"Enviamos os dados necessários para","modalTitle":"Pronto! A ajuda já está a caminho do seu e-mail. :)","title":"Relaxa! Isso acontece com todo mundo.","veloeLogoAlt":"Logo Veloe"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ForgotPassword/data.json
// module id = 2122
// module chunks = 0